/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Engagement segmentation & retention (026 US4) on the shared au-panel system.
 * Pausing users bucketed by pause count in range (one-time / occasional / regular /
 * power), each with count + share, plus the explicit "paused once then never
 * returned" figure. Text only; tabular numerals.
 *
 * Props: { data } — { buckets:[{bucket,users,share_pct}], total_pausing_users, paused_once_never_returned }
 */
const LABELS = {
  'one-time': 'One-time (1 pause)',
  occasional: 'Occasional (2–4)',
  regular: 'Regular (5–9)',
  power: 'Power (10+)',
};

const PauseEngagementBuckets = ({ data = {} }) => {
  const buckets = Array.isArray(data.buckets) ? data.buckets : [];
  const total = Number(data.total_pausing_users) || 0;
  const neverReturned = Number(data.paused_once_never_returned) || 0;

  return (
    <div data-testid="pause-engagement">
      <h3 className="au-seg-title">Engagement &amp; retention — who is sticking</h3>
      <div className="au-panel">
        {total > 0 ? (
          <>
            <ul className="pause-rows">
              {buckets.map((b) => (
                <li key={b.bucket}>
                  <span className="pause-rows__label">{LABELS[b.bucket] || b.bucket}</span>
                  <span className="pause-rows__val">{Number(b.users).toLocaleString()} users ({b.share_pct}%)</span>
                </li>
              ))}
            </ul>
            <div className="pause-callout" data-testid="pause-never-returned">
              Paused once then never returned: <b>{neverReturned.toLocaleString()}</b> of {total.toLocaleString()} pausing users
            </div>
          </>
        ) : (
          <div className="au-chart-empty">No users paused in this range.</div>
        )}
      </div>
    </div>
  );
};

export default PauseEngagementBuckets;
